import { Typography } from '@aloft/toolkit-sui';

import { HoverPopover } from '../../shared/HoverPopover.tsx';
import { usePropertyField } from './shared/usePropertyField.tsx';
import { readOnlyFieldProps } from './styles.ts';
import type { PropertyGridFieldProps } from './types.ts';

export const ReadOnlyField = ({
  columnIndex,
  field,
  colSpan = 1,
  isArv = false,
  control,
  getValues,
  gridType,
}: PropertyGridFieldProps) => {
  const { displayValue } = usePropertyField({ columnIndex, field, isArv, control, getValues });
  const isSensitivityGrid = gridType === 'SensitivityGrid';

  const props = readOnlyFieldProps(colSpan);
  if (isSensitivityGrid) {
    props.__dangerDoNotUseSx = {
      ...props.__dangerDoNotUseSx,
      backgroundColor: 'white',
    };
  }

  const propertyId = getValues(`columns.${columnIndex}.propertyId`);
  const valueTooltip = field.renderValueTooltip?.(propertyId);

  if (!valueTooltip) return <Typography {...props}>{displayValue}</Typography>;

  return (
    <Typography {...props}>
      <HoverPopover renderContent={valueTooltip}>
        <Typography
          inline
          variant="body1"
          color="buttonDefault"
          __dangerDoNotUseSx={{
            fontWeight: 'bold',
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textUnderlineOffset: '2px',
            cursor: 'help',
          }}
        >
          {displayValue}
        </Typography>
      </HoverPopover>
    </Typography>
  );
};
